import {
  HealthProfile,
  HealthProfileSummary,
  MedicalDetailType,
} from "@/types/health-profile";
import { BaseService } from "./base.service";

export class HealthProfileService extends BaseService {
  constructor() {
    super("/member-profiles");
  }

  async createOrUpdate(memberId: string, profile: HealthProfile) {
    return await this.post<HealthProfile>(
      `/member-profiles/create-or-update/${memberId}`,
      profile
    );
  }

  async getProfile(memberId: string) {
    return await this.get<HealthProfile>(`/${memberId}`);
  }

  async getProfileField(memberId: string, type: MedicalDetailType) {
    return await this.get<HealthProfile>(`/${memberId}/${type}`);
  }

  async getProfileSummary(memberId: string) {
    return await this.get<HealthProfileSummary>(`/summary/${memberId}`);
  }

  async createOrUpdateField(
    memberId: string,
    type: MedicalDetailType,
    updatedProfile: HealthProfile
  ) {
    return await this.post<HealthProfile>(
      `/updateField/${memberId}/${type}`,
      updatedProfile
    );
  }

  async updateNone(memberId: string, type: MedicalDetailType) {
    return await this.put<HealthProfile>(`/updateNone/${memberId}/${type}`);
  }

  async updateContext(memberId: string, context: string | null) {
    return await this.put<HealthProfile>(`/${memberId}`, { context });
  }

}

export const healthProfileService = new HealthProfileService();
